import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import tinyMobileHomeADUImage from '@/assets/tiny-mobile-home-adu.jpg';

const CanTinyMobileHomeBeADUCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/tiny-mobile-home-adu-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={tinyMobileHomeADUImage} 
              alt="Tiny home on permanent foundation as ADU" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              Can a Tiny Home or Mobile Home be an ADU in California?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Explore if a tiny home or mobile home qualifies as an ADU in California, including compliance with state building codes and city regulations.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Tiny Home and Mobile Home Regulations for ADUs
              </h2>
              <p className="text-white leading-relaxed mb-6">
                California allows tiny homes and mobile homes to qualify as ADUs if they meet specific requirements: permanent foundation installation, compliance with California Building Code standards, proper utility connections, and local permitting approval. The structure must be designed as a permanent dwelling unit rather than temporary housing.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Legal Requirements and Code Compliance
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Tiny homes on wheels must be converted to permanent foundations to qualify as ADUs. Mobile homes require HUD certification updates, permanent utility connections, and compliance with current accessibility standards. Both must meet fire safety codes, insulation requirements, and local design standards for residential structures.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                City-specific Guidelines in California
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Cities vary in their acceptance of alternative ADU construction methods. Some jurisdictions actively promote tiny home ADUs through streamlined permitting, while others require extensive modifications to meet local codes. Mobile home ADUs may face additional scrutiny regarding aesthetic compatibility with neighborhood standards and long-term structural integrity.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: Are mobile homes legally recognized as ADUs?</p>
                  <p>A: Yes, if they meet California building codes, permanent foundations, and local city requirements.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: Can tiny homes on wheels become ADUs?</p>
                  <p>A: Typically, they must be on a permanent foundation and meet local codes to qualify as ADUs.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default CanTinyMobileHomeBeADUCalifornia;